import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-[#0B7CB5]/5 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our <span className="text-[#0B7CB5]">Clients Say</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our clients trust us because we show up, deliver quality, and treat every home with care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 relative"
            >
              <Quote className="absolute top-6 right-6 w-12 h-12 text-[#5CC4E8]/20" />
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed italic">"{testimonial.text}"</p>
              <div className="border-t pt-4">
                <p className="font-bold text-gray-900">{testimonial.name}</p>
                <p className="text-sm text-gray-600">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Google Reviews Section */}
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-2xl shadow-lg text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            See All Our <span className="text-[#0B7CB5]">Google Reviews</span>
          </h3>
          <p className="text-gray-600 mb-6">
            Read more reviews from our satisfied clients on Google
          </p>
          <a
            href="https://www.google.com/search?q=custom+maids+rva&sca_esv=5d0829feba272f6b&sxsrf=AE3TifOac54N6i4WB5CpM9E-Tm0QBbZGoQ%3A1764910604186&ei=DGYyadCOC-yy5NoPzO2n6As&ved=0ahUKEwjQxP2s1KWRAxVsGVkFHcz2Cb0Q4dUDCBE&uact=5&oq=custom+maids+rva&gs_lp=Egxnd3Mtd2l6LXNlcnAiEGN1c3RvbSBtYWlkcyBydmEyBBAjGCcyBBAjGCcyChAjGIAEGCcYigUyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTIIEAAYgAQYogQyCBAAGKIEGIkFMggQABiiBBiJBTIIEAAYogQYiQVI_RNQpQZYpQZwAXgAkAEAmAGhAaABoQGqAQMwLjG4AQPIAQD4AQGYAgKgAqoBwgIHEAAYsAMYHsICDhAAGIAEGLADGIYDGIoFwgIIEAAYsAMY7wXCAgsQABiwAxiiBBiJBcICCxAAGIAEGLADGKIEmAMAiAYBkAYGkgcDMS4xoAfQCLIHAzAuMbgHpQHCBwMyLTLIBwc&sclient=gws-wiz-serp#lrd=0x6ae386814e6e4dcd:0x2d15c83471a6b062,1,,,,"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-3 bg-[#0B7CB5] hover:bg-[#095a87] text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-200 hover:shadow-xl"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            <span>View All Reviews on Google</span>
          </a>
        </div>
      </div>
    </section>
  );
};